import React from 'react';
import 'leaflet/dist/leaflet.css';

import MapView from '../mapcomponents/MapView';
import Dashboard from '../components/Dashboard';
import Timeline from '../components/Timeline';
import Sponsors from '../components/Sponsors';
import Charities from '../components/Charities';
import TopBar from '../components/TopBar'; // ✅ Import it
import config from '../config';

export default function Page() {
  return (
    <div style={{ fontFamily: 'Inter, sans-serif', backgroundColor: '#ffffff' }}>
      {/* ✅ Top Bar with logo and download button */}
      <TopBar />

      {/* Map section */}
      <div style={{ height: '70vh', width: '100%' }}>
        <MapView />
      </div>

      {/* Timeline & Dashboard */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          padding: '1rem',
          backgroundColor: '#fff',
        }}
      >
        <div className="responsive-box white-box">
          <Timeline />
        </div>

        <div className="responsive-box white-box">
          <Dashboard />
        </div>
      </div>

      {config.showCharities && (
        <div style={{ padding: '1rem' }}>
          <Charities />
        </div>
      )}

      {config.showSponsors && (
        <div style={{ padding: '1rem' }}>
          <Sponsors />
        </div>
      )}

      {/* Optional: your existing responsive styles */}
      <style>
        {`
          .responsive-box {
            flex: 1;
          }

          .white-box {
            background: white;
            border: 1px solid #e0e0e0;
            border-radius: 8px;
            padding: 1rem;
          }

          @media (min-width: 1200px) {
            .responsive-box {
              width: 50%;
            }

            div[style*="display: flex"] {
              flex-direction: row !important;
              justify-content: center;
              align-items: flex-start;
            }
          }
        `}
      </style>
    </div>
  );
}
